import { DownOutlined } from '@ant-design/icons';
import { Breadcrumb, Checkbox, InputNumber, Select, Space, Menu, Dropdown } from 'antd';
import { Form, Input, Button, Spin, DatePicker, message } from 'antd';
import { Steps } from 'antd';
import { Divider } from 'antd';
import { Radio } from 'antd';
import 'moment/locale/bs';
import Cookies from 'js-cookie';
import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from 'react-query';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import uuid from 'uuid-random';

import Payment from 'components/payment';

import { obituaryService } from 'config/services';
import './index.scss';

import { HttpError } from 'helpers/http';

import {
  Obituary,
  ObituaryInfo,
  ObituaryPayload,
  ObituaryPayloadWithId,
  OFormat,
  People,
} from 'types/services/obituary';

import { citiesList as cities } from '../../assets/cities';

import { ImageUpload } from './components/UploadImages/ImageUpload';

export const ObituaryPage = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [current, setCurrent] = useState(0);
  const { id } = useParams<{ id?: string }>();
  const [clickedObituary, setClickedObituary] = useState('54');
  const location = useLocation();
  const [isCreated, setIsCreated] = useState(false);
  const [signatureGenerated, setSignatureGenerated] = useState(false);
  const [obituaryFormatName, setObituaryFormatName] = useState('12,5 x 9 cm');

  const [obituaries, setObituaries] = useState<People[]>([
    {
      birth_approx: '',
      birth_date: null,
      birth_end: null,
      birth_end_approx: '',
      additional_name: '',
      maiden_name: '',
      filename: '',
      firstName: '',
      lastName: '',
      //wantAniversary: 'false',
      imagePreferance: '2',
    },
  ]);

  const [citiesListNew, setCitiesList] = useState<any[]>(['Odaberite lokaciju', ...cities]);
  //promijenili na skracene nazive jer antd datepicker koristi momentjs u pozadini
  // moment.updateLocale('bs', {
  //   weekdaysMin: ['Pon', 'Uto', 'Sri', 'Čet', 'Pet', 'Sub', 'Ned'],
  // });

  moment.locale('bs');
  // moment.updateLocale('bs', {
  //   weekdaysMin: ['Ned', 'Pon', 'Uto', 'Sri', 'Čet', 'Pet', 'Sub'],
  //   week: {
  //     dow: 1,
  //   },
  // });

  const [obituaryInfo, setObituaryInfo] = useState<ObituaryInfo>({
    publishedDate: new Date(),
    personal_message: '',
    introductory_text: '',
    main_text: '',
    bereaved: '',
    note: '',
    num_of_persons: 1,
    leaveNumber: '',
    nameSurname: '',
    companyName: '',
    companyAddress: '',
    companyPDV: '',
    city: '',
    //billId: '',
  });

  useEffect(() => {
    //form.setFieldsValue({ city: null });
    form.setFieldsValue({ obituaryType: '1' });
  }, []);

  const dateToFormat = new Date();
  const newFormatedDate =
    String(dateToFormat.getMonth() + 1) +
    String(dateToFormat.getDate()) +
    String(dateToFormat.getHours()) +
    String(dateToFormat.getMinutes());
  //TODO: provjeriti da li je ok duzina uuid-a, da li je ok da na ovaj nacin generisemo uuid ? sta cemo dodati za order id
  const [uuidState, setUuidState] = useState(uuid().slice(0, 10) + newFormatedDate);

  const { data: obituary, isLoading } = useQuery<Obituary, HttpError>(
    ['getObituary', id],
    () => obituaryService.getObituaryById(parseInt(id || '')),
    {
      enabled: typeof id !== 'undefined',
    },
  );
  const [obituaryType, setObituaryType] = useState(obituary?.type ? String(obituary.type.id) : '1');

  const [selectedOption, setSelectedOption] = useState(1);

  const handleOptionClick = (option: number) => {
    setSelectedOption(option);
  };

  const menu = (
    <Menu>
      {Array.from({ length: 200 }, (_, index) => (
        <Menu.Item
          key={index + 1}
          onClick={() => {
            handleOptionClick(index + 1);
            onChangePersonNumber(index + 1);
            // setTimeout(() => {
            //   onChangePersonNumber(3);
            // }, 2000);
          }}
        >
          {index + 1}
        </Menu.Item>
      ))}
    </Menu>
  );

  function addDayToPublishedDate(publishedDate: any) {
    const publishedDateTime = moment(publishedDate);
    const currentTime = moment().format('HH:mm');

    // Check if the time is after 17:00
    if (currentTime > '17:00') {
      publishedDateTime.add(2, 'days');
    } else {
      publishedDateTime.add(1, 'day');
    }

    while (publishedDateTime.day() === 0) {
      publishedDateTime.add(1, 'day');
    }

    // skipping the forbidden date (dvobroj) for date picker
    if (publishedDateTime.format('DDMMYYYY') === '01032024') publishedDateTime.add(1, 'day');

    // skipping the forbidden date (holiday) for date picker
    if (publishedDateTime.format('DDMMYYYY') === '10042024') publishedDateTime.add(1, 'day');
    if (publishedDateTime.format('DDMMYYYY') === '25112024') publishedDateTime.add(1, 'day');

    // skipping the forbidden dates (troboj 1. maj) for date picker
    if (publishedDateTime.format('DDMMYYYY') === '01052025') publishedDateTime.add(2, 'day');
    if (publishedDateTime.format('DDMMYYYY') === '02052025') publishedDateTime.add(1, 'day');

    // skipping the forbidden dates (troboj 1. januar) for date picker
    if (publishedDateTime.format('DDMMYYYY') === '31122024') publishedDateTime.add(3, 'day');
    if (publishedDateTime.format('DDMMYYYY') === '01012025') publishedDateTime.add(2, 'day');
    if (publishedDateTime.format('DDMMYYYY') === '02012025') publishedDateTime.add(1, 'day');

    // skipping the forbidden date (trobroj 1. mart and sunday is next day, that's why 2 is added instead of 1)
    if (publishedDateTime.format('DDMMYYYY') === '01032025') publishedDateTime.add(2, 'day');

    if (publishedDateTime.format('DDMMYYYY') === '31032025') publishedDateTime.add(1, 'day');
    if (publishedDateTime.format('DDMMYYYY') === '06062025') publishedDateTime.add(1, 'day');

    return publishedDateTime;
  }

  useEffect(() => {
    if (obituary) setSelectedOption(obituary?.people_id.length);
    if (obituary?.obituaryFormat?.id) {
      setClickedObituary(String(obituary?.obituaryFormat.id));
      var img = document.querySelectorAll('.obituary-active');
      img.forEach((i) => {
        i.classList.remove('obituary-active');
      });
      const x = document.getElementById(String(obituary?.obituaryFormat.id));
      if (x) x.classList.add('obituary-active');
    }

    if (obituary?.type.id) {
      setObituaryType(String(obituary?.type.id));
      form.setFieldsValue({
        obituaryType: String(obituary?.type.id),
      });
    }
    form.setFieldsValue({
      publicationTime: !location.pathname.includes('/obituary/')
        ? addDayToPublishedDate(moment(obituary?.published_date))
        : moment(obituary?.published_date),
      numOfPersons: obituary?.people_id.length,
      personal_message: obituary?.personal_message,
      intro: obituary?.introductory_text,
      mainText: obituary?.main_text,
      bereaved: obituary?.bereaved,
      leaveNumber: obituary?.leaveNumber,
      nameSurname: obituary?.nameSurname,
      companyName: obituary?.companyName,
      companyAddress: obituary?.companyAddress,
      companyPDV: obituary?.companyPDV,
      //city: obituary?.city,
      note: obituary?.note,
    });
    obituary?.people_id.forEach((element, idx) => {
      let str = [
        'name' + idx,
        'surname' + idx,
        'additionalName' + idx,
        'maidenName' + idx,
        'dateOfBirth' + idx,
        'dateOfDeath' + idx,
        //'wantAniversary' + idx,
        'imagePreferance' + idx,
        'dateApprox' + idx,
        'dateEndApprox' + idx,
      ];
      form.setFieldsValue({
        [str[0]]: element.firstName,
        [str[1]]: element.lastName,
        [str[2]]: element.additional_name,
        [str[3]]: element.maiden_name,
        //[str[6]]: element.wantAniversary,
        [str[6]]: element.imagePreferance,
        [str[7]]: element.birth_approx,
        [str[8]]: element.birth_end_approx,
      });
      if (element.birth_date) {
        form.setFieldsValue({ [str[4]]: moment(element.birth_date) });
      }
      if (element.birth_end) {
        form.setFieldsValue({ [str[5]]: moment(element.birth_end) });
      }
    });
    //TODO: povecati broj osoba u obituaries u ovisnosti od velicine people id, a onda napraviti petlju koja ce napuniti obituaries sa vrijednostima iz people id
    //TODO: treba ostati set fields value, a dodati ovu iz prvog todo-a
    obituaries[0].filename = obituary?.people_id[0].filename;

    if (obituary !== undefined) {
      setObituaryType(String(obituary.type.id));
      if (obituary.type.id === 1) {
        const btn1 = document.getElementById('btn1');
        btn1?.classList.add('clicked-type');
        btn1?.classList.remove('not-clicked-type');
        const btn2 = document.getElementById('btn2');
        btn2?.classList.remove('clicked-type');
        btn2?.classList.add('not-clicked-type');
        const btn3 = document.getElementById('btn3');
        btn3?.classList.remove('clicked-type');
        btn3?.classList.add('not-clicked-type');
      } else if (obituary.type.id === 2) {
        const btn2 = document.getElementById('btn2');
        btn2?.classList.add('clicked-type');
        btn2?.classList.remove('not-clicked-type');
        const btn1 = document.getElementById('btn1');
        btn1?.classList.remove('clicked-type');
        btn1?.classList.add('not-clicked-type');
        const btn3 = document.getElementById('btn3');
        btn3?.classList.remove('clicked-type');
        btn3?.classList.add('not-clicked-type');
      } else if (obituary.type.id === 3) {
        const btn3 = document.getElementById('btn3');
        btn3?.classList.add('clicked-type');
        btn3?.classList.remove('not-clicked-type');
        const btn2 = document.getElementById('btn2');
        btn2?.classList.remove('clicked-type');
        btn2?.classList.add('not-clicked-type');
        const btn1 = document.getElementById('btn1');
        btn1?.classList.remove('clicked-type');
        btn1?.classList.add('not-clicked-type');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [obituary]);

  const { data: obituaryFormat } = useQuery<OFormat, HttpError>('getObituaryFormat', () =>
    obituaryService.getObituaryFormat(),
  );

  useEffect(() => {
    if (obituaryFormat) {
      const obituaryFormatCopy = obituaryFormat?.data.filter((of) => String(of.id) === clickedObituary);
      setObituaryFormatName(obituaryFormatCopy[0].name);
    }
  }, [clickedObituary]);

  const { mutateAsync: createObituary } = useMutation('createObituary', (obituaryPayload: ObituaryPayload) =>
    obituaryService.create(obituaryPayload),
  );

  const { mutateAsync: updateObituary } = useMutation('updateObituary', (obituaryPayload: ObituaryPayloadWithId) =>
    obituaryService.patch(obituaryPayload),
  );

  const IconArrow = () => (
    <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.839844 1.41L5.41984 6L0.839844 10.59L2.24984 12L8.24984 6L2.24984 0L0.839844 1.41Z" fill="#8B8B8B" />
    </svg>
  );

  const clickedObitauries = (id: string, e: any) => {
    setClickedObituary(id);
    var img = document.querySelectorAll('.onHover > div > button');
    img.forEach((i) => {
      i.classList.remove('obituary-active');
    });
    const x = document.getElementById(id);
    if (x) {
      x.classList.add('obituary-active');
    }
  };

  const next = (index: number) => {
    let toContinue = true;

    window.scrollTo({
      top: 0,
      behavior: 'smooth', // This enables smooth scrolling
    });

    //ovdje odradit ono sto se nalazi u onconfirm changes da se dobije cropana slika i njen url smjestit u state
    if (index === 1) {
      obituaries.forEach((o, i) => {
        o.firstName = form.getFieldValue('name' + i);
        o.lastName = form.getFieldValue('surname' + i);
        o.additional_name = form.getFieldValue('additionalName' + i) ? form.getFieldValue('additionalName' + i) : '';
        o.maiden_name = form.getFieldValue('maidenName' + i) ? form.getFieldValue('maidenName' + i) : '';
        o.birth_date = form.getFieldValue('dateOfBirth' + i);
        o.birth_end = form.getFieldValue('dateOfDeath' + i);
        o.imagePreferance = form.getFieldValue('radioGroupImage' + i);
        o.birth_approx = form.getFieldValue('dateApprox' + i) ? form.getFieldValue('dateApprox' + i) : '';
        o.birth_end_approx = form.getFieldValue('dateEndApprox' + i) ? form.getFieldValue('dateEndApprox' + i) : '';
        // o.filename = form.getFieldValue('thumbnailImage' + i);
      });
      setObituaryInfo({
        publishedDate: form.getFieldValue('publicationTime'),
        personal_message: form.getFieldValue('personal_message'),
        introductory_text: form.getFieldValue('intro'),
        main_text: form.getFieldValue('mainText'),
        bereaved: form.getFieldValue('bereaved'),
        note: form.getFieldValue('note'),
        num_of_persons: selectedOption,
        leaveNumber: form.getFieldValue('leaveNumber'),
        nameSurname: form.getFieldValue('nameSurname'),
        companyName: form.getFieldValue('companyName'),
        companyAddress: form.getFieldValue('companyAddress'),
        companyPDV: form.getFieldValue('companyPDV'),
        city: form.getFieldValue('city'),

        //billId: form.getFieldValue('billId'),
      });
      form
        .validateFields()
        .then((values) => {
          let strings: string[] = [
            'intro',
            'personal_message',
            'additionalName',
            'thumbnailImage',
            'mainText',
            'note',
            // 'wantAniversary',
            //'billId',
            'maidenName',
            'dateOfBirth',
            'surname',
            'dateOfDeath',
            'dateApprox',
            'dateEndApprox',
            'city',
          ];

          for (const property in values) {
            if (strings.filter((s) => property.startsWith(s)).length > 0) {
              continue;
            } else {
              if (values[property] === undefined) {
                toContinue = false;
              }
            }
          }
          if (toContinue) {
            form.setFieldsValue({
              numOfPersons: selectedOption ? selectedOption : 1,
              obituaryType: form.getFieldValue('obituaryType') ? form.getFieldValue('obituaryType') : 1,
            });
            generateValuesForPeople(selectedOption, obituary);
            setCurrent(current + 1);
          }
        })
        .catch((errorInfo) => {
          console.log(errorInfo, 'errorInfo');
        });
    } else {
      form.setFieldsValue({
        numOfPersons: selectedOption ? selectedOption : 1,
        obituaryType: form.getFieldValue('obituaryType') ? form.getFieldValue('obituaryType') : 1,
      });
      generateValuesForPeople(selectedOption, obituary);
      setCurrent(current + 1);
    }
  };

  const prev = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // This enables smooth scrolling
    });
    setCurrent(current - 1);
  };

  const setImage = (index: number, newFile: string) => {
    obituaries[index].filename = newFile;
  };

  const saveObituary = (values: any) => {
    const isUpdate = id && obituary;

    const obituaryPayload = {
      publishedDate: obituaryInfo.publishedDate,
      uuid: uuidState, //'012b626b-5399-42b1-81d3-da23883c076d',
      personal_message: obituaryInfo.personal_message,
      introductory_text: obituaryInfo.introductory_text,
      main_text: obituaryInfo.main_text,
      bereaved: obituaryInfo.bereaved,
      note: obituaryInfo.note ? obituaryInfo.note : '',
      num_of_persons: obituaryInfo.num_of_persons,
      createdBy: null,
      people_id: obituaries,
      obituaryFormatId: clickedObituary,
      typeId: obituaryType,
      leaveNumber: obituaryInfo.leaveNumber,
      nameSurname: obituaryInfo.nameSurname,
      companyName: obituaryInfo.companyName,
      companyAddress: obituaryInfo.companyAddress,
      companyPDV: obituaryInfo.companyPDV,
      city: obituaryInfo.city,
      //billId: obituaryInfo.billId,
      status: !location.pathname.includes('/obituary') ? '2' : '1',
    };

    if (!isUpdate && !location.pathname.includes('/obituary')) Cookies.set('uuid', uuidState);

    return isUpdate
      ? updateObituary({ id: obituary?.id, ...obituaryPayload })
      : createObituary(obituaryPayload).then((x) => {
          setIsCreated(true);
          return x;
        });
  };

  const onFinish = (values: any) => {
    const currentTime = moment().format('HH:mm');
    let currentDate = moment().add(1, 'days').format('DDMMYYYY');
    // Check if the time is after 17:00
    if (
      !location.pathname.includes('/obituary/') &&
      currentTime > '17:00' &&
      currentDate === form.getFieldValue('publicationTime').format('DDMMYYYY')
    ) {
      prev();

      window.alert('Zakasnili ste sa uplatom za ovaj datum objave. Molimo Vas odaberite drugi datum!');
    } else {
      const promise = saveObituary(values);
      const isUpdate = id && obituary;
      promise
        .then((obituary) => {
          location.pathname.includes('/obituary/') &&
            message.success(
              t(`common:Successfully ${isUpdate ? 'Updated' : 'Created'}`, { resource: t('article:Obituary') }),
            );
          if (!isUpdate && location.pathname.includes('/obituary/')) {
            history.push(`/obituaries`);
          }

          if (isUpdate && location.pathname.includes('/obituary/')) {
            history.push(`/obituaries`);
          }
        })
        .catch((e) => {
          message.error(
            location.pathname.includes('/obituary/') &&
              t('common:Action failed', {
                action: t(`common:${isUpdate ? 'Update' : 'Creation'}`),
                resource: t('article:Obituary').toLowerCase(),
                suffix: 'a',
              }),
          );
          console.error(e);
        });
    }
  };

  const calculatePrice = (numOfPersons: number) => {
    const targetObituaryFormat = obituaryFormat?.data.filter((o) => String(o.id) === clickedObituary);
    let total_price = 0;
    if (targetObituaryFormat) total_price = Number(targetObituaryFormat[0].price) + (numOfPersons - 1) * 10;
    return total_price;
  };

  const dataLoading = false;

  const onChangePersonNumber = (value: number) => {
    let newPerson = {
      birth_approx: '',
      birth_date: null,
      birth_end: null,
      birth_end_approx: '',
      additional_name: '',
      maiden_name: '',
      filename: '',
      firstName: '',
      lastName: value,
      //wantAniversary: 'false',
      imagePreferance: '2',
    };
    let numberOfPeople = obituaries.length;
    let copy: any[] = [...obituaries];
    while (numberOfPeople !== value) {
      if (numberOfPeople < value) {
        let newPersonShallow = Object.assign({}, newPerson);
        copy.push(newPersonShallow);
        numberOfPeople += 1;
      } else if (numberOfPeople > value) {
        copy.pop();
        numberOfPeople -= 1;
      }
    }
    setObituaries(copy);
  };

  const generateValuesForPeople = (value: number, obituary: any) => {
    if (obituary && value === obituary.people_id.length) {
      setObituaries(obituary?.people_id);
    } else {
      obituary?.people_id.forEach((p: any, idx: number) => {
        let newPerson = {
          birth_approx: p.birth_approx,
          birth_date: p.birth_date,
          birth_end: p.birth_end,
          birth_end_approx: p.birth_end_approx,
          additional_name: p.additional_name,
          maiden_name: p.maiden_name,
          filename: p.filename,
          firstName: p.firstName,
          lastName: p.lastName,
          //wantAniversary: p.wantAniversary,
          imagePreferance: p.imagePreferance,
        };
        let numberOfPeople = obituaries.length;
        let copy: any[] = [...obituaries];
        while (numberOfPeople !== value) {
          if (numberOfPeople < value) {
            copy.push(newPerson);
            numberOfPeople += 1;
          } else if (numberOfPeople > value) {
            copy.pop();
            numberOfPeople -= 1;
          }
        }
        setObituaries(copy);
      });
    }
  };

  const { Step } = Steps;

  useEffect(() => {
    if (signatureGenerated) {
      var x = document.getElementById('paymentMethod') as any;

      if (x && signatureGenerated) {
        x.submit();
      }
    }
  }, [signatureGenerated]);

  const fun = () => {
    setSignatureGenerated(true);
  };

  const useMediaQuery = (width: number) => {
    const [targetReached, setTargetReached] = useState(false);

    const updateTarget = useCallback((e) => {
      if (e.matches) {
        setTargetReached(true);
      } else {
        setTargetReached(false);
      }
    }, []);

    useEffect(() => {
      const media = window.matchMedia(`(max-width: ${width}px)`);
      media.addEventListener('change', updateTarget);
      // Check on mount (callback is not called until a change occurs)
      if (media.matches) {
        setTargetReached(true);
      }

      return () => media.removeEventListener('change', updateTarget);
    }, []);

    return targetReached;
  };

  const isBreakpoint = useMediaQuery(768);

  const [formData, setFormData] = useState({
    intro: '',
    bereaved: '',
  });

  const handleInputChange = (event: any) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const onChange = (value: number) => {
    setCurrent(value);
  };

  const areFieldsEntered = (paymentStep?: boolean) => {
    const intro = form.getFieldValue('intro');
    const bereaved = form.getFieldValue('bereaved');
    const leaveNumber = form.getFieldValue('leaveNumber');
    const nameSurname = form.getFieldValue('nameSurname');

    const allNames = obituaries.map((o, i) => {
      return form.getFieldValue('name' + i);
    });

    const allNames2 = allNames.every((element) => typeof element !== 'undefined' && element !== '');

    const result = intro && bereaved && allNames2;

    return paymentStep ? result && leaveNumber && nameSurname : result;
  };

  useEffect(() => {
    //form.setFieldsValue({ city: null });
    form.setFieldsValue({ city: obituary?.city });
  }, [isLoading, obituary]);

  return (
    <>
      {dataLoading ? (
        <div style={{ padding: '10px', textAlign: 'center' }}>
          <Spin size="large" />
        </div>
      ) : null}
      <div
        className="steps-custom-container"
        style={{ display: location.pathname.includes('objavi') ? 'block' : 'none' }}
      >
        <Steps current={current} className="steps-custom-styles" onChange={onChange}>
          <Step
            key={0}
            className={`${location.pathname.includes('/obituary/') ? 'step-createObituary' : ''}`}
            title="Odaberite format"
            status={'wait'}
          />
          <Step
            key={1}
            className={`${location.pathname.includes('/obituary/') ? 'step-createObituary' : ''}`}
            title="Unesite podatke"
            status={'wait'}
          />
          <Step
            key={2}
            className={`${location.pathname.includes('/obituary/') ? 'step-createObituary' : ''}`}
            title="Pregled"
            status={'wait'}
            disabled={!areFieldsEntered()}
          />
          <Step
            key={3}
            className={`${location.pathname.includes('/obituary/') ? 'step-createObituary' : ''}`}
            title="Plaćanje"
            status={'wait'}
            disabled={!areFieldsEntered(true)}
          />
        </Steps>
      </div>

      {current === 0 && (
        <div className="container-obituaries">
          <div className="container-small">
            <div className="flex">
              <p
                className="paddingOnMobile"
                style={{
                  whiteSpace: 'pre',
                  marginTop: '12px',
                  marginRight: '9px',
                  fontFamily: 'DM Sans',
                  fontStyle: 'normal',
                  fontWeight: '700',
                  fontSize: '16px',
                  lineHeight: '21px',
                  color: '#333333',
                }}
              >
                Odaberite format za novinu
              </p>
              <Divider style={{ minWidth: '0' }} />
            </div>
            <div className="flex container-main main-content">
              <div
                style={{
                  backgroundColor: 'white',
                  border: '1px solid #E3E3E3',
                  paddingTop: '30px',
                  paddingLeft: '8px',
                  display: 'flex',
                  flexDirection: 'column',
                  paddingBottom: '30px',
                }}
                className="onHover"
              >
                <div className="flex" style={{ marginBottom: '10px' }}>
                  <button
                    id={'54'}
                    className="obituary-active popup iosPadding"
                    onClick={(e) => {
                      clickedObitauries('54', e);
                    }}
                    style={{ marginRight: '5px', padding: '0' }}
                  >
                    <div className="popup-content">
                      <p>Cijena: 98.00 KM</p>
                    </div>
                    <div className="png1">
                      <div className="png11" id="png1-1"></div>
                      <p className="formatText">12,5 x 9 cm</p>
                    </div>
                    {/* <img src="/1.png" alt="" style={{ width: '135px', height: '95px' }}></img> */}
                  </button>
                  <button
                    className="popup iosPadding"
                    id={'49'}
                    onClick={(e) => {
                      clickedObitauries('49', e);
                    }}
                    style={{ marginRight: '5px', padding: '0', height: '89px' }}
                  >
                    <div className="popup-content">
                      <p>Cijena: 23.00 KM</p>
                    </div>
                    <div className="png2">
                      <div className="png22" id="png2-2"></div>
                      <p className="formatText">3,5 x 8 cm</p>
                    </div>
                    {/* <img src="/2.png" alt="" style={{ width: '40px', height: '85px' }}></img> */}
                  </button>
                  <button
                    className="popup iosPadding"
                    id={'51'}
                    onClick={(e) => {
                      clickedObitauries('51', e);
                    }}
                    style={{ padding: '0', height: '69px' }}
                  >
                    <div className="popup-content">
                      <p>Cijena: 44.00 KM</p>
                    </div>
                    <div className="png3">
                      <div className="png33" id="png3-3"></div>
                      <p
                        className="formatText"
                        style={{
                          marginTop: 'auto',
                          marginBottom: '0px',
                          marginRight: 'auto',
                          paddingLeft: '8px',
                          paddingBottom: '8px',
                        }}
                      >
                        8 x 6 cm
                      </p>
                    </div>
                    {/* <img src="/3.png" alt="" style={{ width: '90px', height: '65px' }}></img> */}
                  </button>
                </div>
                <div className="flex" style={{ marginBottom: '10px' }}>
                  <button
                    className="popup iosPadding"
                    id={'56'}
                    onClick={(e) => {
                      clickedObitauries('56', e);
                    }}
                    style={{ padding: '0' }}
                  >
                    <div className="popup-content">
                      <p>Cijena: 190.00 KM</p>
                    </div>
                    <div className="png4">
                      <div className="png44" id="png4-4"></div>
                      <p
                        className="formatText"
                        style={{
                          marginTop: 'auto',
                          marginBottom: '0px',
                          marginRight: 'auto',
                          paddingLeft: '8px',
                          paddingBottom: '8px',
                        }}
                      >
                        25,5 x 9 cm
                      </p>
                    </div>
                    {/* <img src="/4.png" alt="" style={{ width: '275px', height: '100px' }}></img> */}
                  </button>
                </div>
                <div className="flex" style={{ marginBottom: '10px' }}>
                  <button
                    className="popup iosPadding"
                    id={'55'}
                    onClick={(e) => {
                      clickedObitauries('55', e);
                    }}
                    style={{ padding: '0' }}
                  >
                    <div className="popup-content">
                      <p>Cijena: 105.00 KM</p>
                    </div>
                    <div className="png5">
                      <div className="png55" id="png5-5"></div>
                      <p
                        className="formatText"
                        style={{
                          marginTop: 'auto',
                          marginBottom: '0px',
                          marginRight: 'auto',
                          paddingLeft: '8px',
                          paddingBottom: '8px',
                        }}
                      >
                        25,5 x 5 cm
                      </p>
                    </div>
                    {/* <img src="/5.png" alt="" style={{ width: '275px', height: '55px' }}></img> */}
                  </button>
                </div>
                <div className="flex">
                  <button
                    className="popup iosPadding"
                    id={'52'}
                    onClick={(e) => {
                      clickedObitauries('52', e);
                    }}
                    style={{ padding: '0' }}
                  >
                    <div className="popup-content">
                      <p>Cijena: 60.00 KM</p>
                    </div>
                    <div className="png6">
                      <div className="png66" id="png6-6"></div>
                      <p
                        className="formatText"
                        style={{
                          marginTop: 'auto',
                          marginBottom: '0px',
                          marginRight: 'auto',
                          paddingLeft: '8px',
                          paddingBottom: '8px',
                        }}
                      >
                        12,5 x 5 cm
                      </p>
                    </div>
                    {/* <img src="/6.png" alt="" style={{ width: '135px', height: '55px' }}></img> */}
                  </button>
                  <button
                    className="popup iosPadding"
                    id={'50'}
                    onClick={(e) => {
                      clickedObitauries('50', e);
                    }}
                    style={{ padding: '0', marginLeft: '46px' }}
                  >
                    <div className="popup-content">
                      <p>Cijena: 40.00 KM</p>
                    </div>
                    <div className="png7">
                      <div className="png77" id="png7-7"></div>
                      <p
                        className="formatText"
                        style={{
                          marginTop: 'auto',
                          marginBottom: '0px',
                          marginRight: 'auto',
                          paddingLeft: '8px',
                          paddingBottom: '8px',
                        }}
                      >
                        8 x 5 cm
                      </p>
                    </div>
                    {/* <img src="/7.png" alt="" style={{ width: '90px', height: '55px' }}></img> */}
                  </button>
                </div>
              </div>
              <div
                style={{
                  backgroundColor: 'white',
                  border: '1px solid #E3E3E3',
                  display: 'grid',
                  margin: '0px 20px',
                  paddingBottom: '30px',
                }}
                className="onHover"
              >
                <div style={{ display: 'grid' }}>
                  <button
                    className="popup iosPadding marginBottom58"
                    id={'58'}
                    onClick={(e) => {
                      clickedObitauries('58', e);
                    }}
                    style={{
                      width: '275px',
                      height: '190px',
                      marginTop: '30px',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                      padding: '0',
                      // marginBottom: '60px',
                    }}
                  >
                    <div className="popup-content">
                      <p>Cijena: 480.00 KM</p>
                    </div>
                    <div className="png8">
                      <div className="png88" id="png8-8"></div>
                      <p
                        className="formatText"
                        style={{
                          marginBottom: '0px',
                          marginTop: '9px',
                        }}
                      >
                        1/2
                      </p>
                    </div>
                    {/* <img src="/8.png" alt="" style={{ width: '275px', height: '190px' }}></img> */}
                  </button>
                  <button
                    className="popup iosPadding smallDevicesPadding mtSpecific marginBottom57"
                    id={'57'}
                    onClick={(e) => {
                      clickedObitauries('57', e);
                    }}
                    style={{
                      width: '275px',
                      height: '99px',
                      padding: '0',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                      // marginBottom: '10px',
                    }}
                  >
                    <div className="popup-content">
                      <p>Cijena: 300.00 KM</p>
                    </div>
                    <div className="png9">
                      <div className="png99" id="png9-9"></div>
                      <p
                        className="formatText"
                        style={{
                          marginBottom: '0px',
                          marginTop: '9px',
                        }}
                      >
                        1/4
                      </p>
                    </div>
                    {/* <img src="/9.png" alt="" style={{ width: '275px', height: '95px' }}></img> */}
                  </button>
                  <button
                    className="popup iosPadding btn53new"
                    id={'53'}
                    onClick={(e) => {
                      clickedObitauries('53', e);
                    }}
                    style={{ padding: '0' }}
                  >
                    <div className="popup-content">
                      <p>Cijena: 80.00 KM</p>
                    </div>
                    <div className="png61">
                      <div className="png66" id="png6-6"></div>
                      <p
                        className="formatText"
                        style={{
                          marginTop: 'auto',
                          marginBottom: '0px',
                          marginRight: 'auto',
                          paddingLeft: '8px',
                          paddingBottom: '8px',
                        }}
                      >
                        16,5 x 5 cm
                      </p>
                    </div>
                    {/* <img src="/6.png" alt="" style={{ width: '135px', height: '55px' }}></img> */}
                  </button>
                </div>
              </div>
              <div
                style={{ backgroundColor: 'white', border: '1px solid #E3E3E3', paddingBottom: '30px' }}
                className="onHover"
              >
                <div className="flex">
                  <button
                    className="popup iosPadding"
                    id={'59'}
                    onClick={(e) => {
                      clickedObitauries('59', e);
                    }}
                    style={{ padding: '0', marginLeft: 'auto', marginRight: 'auto', marginTop: '30px' }}
                  >
                    <div className="popup-content">
                      <p>Cijena: 870.00 KM</p>
                    </div>
                    <div className="png10">
                      <div className="png1010" id="png10-10"></div>
                      <p
                        className="formatText"
                        style={{
                          marginBottom: '0px',
                          marginTop: '9px',
                        }}
                      >
                        1/1
                      </p>
                    </div>
                    {/* <img src="/10.png" alt="" style={{ width: '275px', height: '380px' }}></img> */}
                  </button>
                </div>
              </div>
            </div>

            {isBreakpoint !== false ? (
              <Button
                className="button-bg widthFirstButton"
                style={{ position: 'sticky', bottom: '3%', height: '40px', marginRight: '-8px' }}
                onClick={() => next(0)}
              >
                <IconArrow></IconArrow>
              </Button>
            ) : (
              <Button className="button-bg nextButtonMt" onClick={() => next(0)}>
                <span className="nextSpan">Sljedeće</span>
                <div className="nextIcon">
                  <IconArrow></IconArrow>
                </div>
              </Button>
            )}
          </div>
        </div>
      )}
      <Form
        layout="vertical"
        form={form}
        name="article-form"
        onFinish={onFinish}
        className="article-form"
        id="obituaryForm"
      >
        {current === 1 && (
          <>
            <div className="enterInfo-container">
              <div className="flex">
                <p style={{ whiteSpace: 'pre', marginTop: '12px', marginRight: '9px' }} className="infoAboutDeceased">
                  Unesite podatke o preminulom
                </p>
                <Divider style={{ minWidth: '0' }} />
              </div>

              {/*  <button
                onClick={(e: any) => {
                  console.log(form.getFieldValue('cityName0'), 'evo je');
                  e.preventDefault();
                  form.setFieldsValue({
                    cityName0: 'Tuzla',
                  });
                }}
              >
                Postavi na ti
              </button>
 */}
              <Form.Item label={t('article:Obituary Type')} name="obituaryType" className="full-w-small">
                <Radio.Group
                  onChange={(e) => {
                    console.log('radio checked', e.target.value);
                    setObituaryType(e.target.value);
                  }}
                  defaultValue="1"
                  buttonStyle="solid"
                  className="radioButtonGroup"
                >
                  <Radio.Button value="1">OBAVIJEST O SMRTI</Radio.Button>
                  <Radio.Button value="2">SJEĆANJE</Radio.Button>
                  <Radio.Button value="3">SUĆUTI</Radio.Button>
                </Radio.Group>
              </Form.Item>
              <div className="flex flex-col">
                {/*  <Form.Item
                  required
                  label={t('article:Obituary Type')}
                  name="obituaryType"
                  className="full-w-small"
                  style={{ marginBottom: '20px', boxShadow: 'none' }}
                >
                  <Button
                    type="primary"
                    id={'btn1'}
                    name={'obituaryTypeX'}
                    className={`${
                      obituary?.type.id === 1
                        ? 'clicked-type'
                        : obituaryType === '1'
                        ? 'clicked-type'
                        : 'not-clicked-type'
                    } common-clicked`}
                    onClick={(e) => {
                      const btn1 = document.getElementById('btn1');
                      btn1?.classList.add('clicked-type');
                      btn1?.classList.remove('not-clicked-type');
                      const btn2 = document.getElementById('btn2');
                      btn2?.classList.remove('clicked-type');
                      btn2?.classList.add('not-clicked-type');
                      const btn3 = document.getElementById('btn3');
                      btn3?.classList.remove('clicked-type');
                      btn3?.classList.add('not-clicked-type');
                      setObituaryType('1');

                    }}
                  >
                    {t('article:Info about death')}
                  </Button>
                  <Button
                    type="primary"
                    id={'btn2'}
                    name={'obituaryTypeX'}
                    className={`${obituary?.type.id === 3 ? 'clicked-type' : 'not-clicked-type'} common-clicked`}
                    style={{ margin: '0 20px', boxShadow: 'none' }}
                    onClick={(e) => {
                      const btn2 = document.getElementById('btn2');
                      btn2?.classList.add('clicked-type');
                      btn2?.classList.remove('not-clicked-type');
                      const btn1 = document.getElementById('btn1');
                      btn1?.classList.remove('clicked-type');
                      btn1?.classList.add('not-clicked-type');
                      const btn3 = document.getElementById('btn3');
                      btn3?.classList.remove('clicked-type');
                      btn3?.classList.add('not-clicked-type');
                      setObituaryType('3');
                    }}
                  >
                    {t('article:Remebering')}
                  </Button>
                  <Button
                    type="primary"
                    id={'btn3'}
                    name={'obituaryTypeX'}
                    style={{ boxShadow: 'none', minWidth: '185px' }}
                    className={`${obituary?.type.id === 2 ? 'clicked-type' : 'not-clicked-type'} common-clicked`}
                    onClick={(e) => {
                      const btn3 = document.getElementById('btn3');
                      btn3?.classList.add('clicked-type');
                      btn3?.classList.remove('not-clicked-type');
                      const btn2 = document.getElementById('btn2');
                      btn2?.classList.remove('clicked-type');
                      btn2?.classList.add('not-clicked-type');
                      const btn1 = document.getElementById('btn1');
                      btn1?.classList.remove('clicked-type');
                      btn1?.classList.add('not-clicked-type');
                      setObituaryType('2');

                    }}
                  >
                    {t('article:Last goodbye')}
                  </Button>
                </Form.Item> */}
                <div className="flex">
                  <Form.Item
                    name="publicationTime"
                    rules={[{ required: true, message: 'Molimo unesite \nDatum objave' }]}
                    label={t('article:Publication date')}
                    style={{ marginBottom: '0px' }}
                    className="small-picker-form"
                  >
                    <DatePicker
                      style={{
                        width: '140px',
                        borderRadius: '5px',
                        borderColor: '#d9d9d9',
                        height: '34px',
                      }}
                      format="DD.MM.YYYY"
                      className="publication small-picker-width"
                      disabledDate={(current) => {
                        // obrisati .add(5, 'days') nad datumom u liniji ispod, koristi se samo za simuliranje subote kao danasnjeg dana
                        let customDate = moment().format('YYYY-MM-DD');
                        // provjera trenutnog dana u sedmici, ukoliko je danas subota disablea se i sljedeci dan, tj. nedjelja
                        let currentDay = moment(customDate, 'YYYY-MM-DD').day();
                        let newDate = moment(current.format('YYYY-MM-DD'), 'YYYY-MM-DD');
                        newDate.subtract(1, 'days');

                        const currentTime = moment().format('HH:mm');

                        const currentDate = moment().startOf('day');
                        const selectedDate = moment(current).startOf('day');
                        const isSunday = selectedDate.day() === 0;

                        // special date that needs to be disabled because of dvobroj print
                        const isDvobroj = selectedDate.format('YYYY-MM-DD') === '2025-06-06';

                        // special day for religious holidays that needs to be disabled
                        const isHoliday = selectedDate.format('YYYY-MM-DD') === '2024-04-10';
                        const isHolidaySecond = selectedDate.format('YYYY-MM-DD') === '2024-11-25';

                        // special dates that need to be disabled because of trobroj print
                        const isTrobrojFirst = selectedDate.format('YYYY-MM-DD') === '2025-05-01';
                        const isTrobrojSecond = selectedDate.format('YYYY-MM-DD') === '2025-05-02';
                        const isTrobrojThird = selectedDate.format('YYYY-MM-DD') === '2025-01-02';

                        const url = window.location.href;
                        const containsObituary = url.includes('/obituary/');

                        // Disable today's date
                        if (currentDate.isSame(selectedDate) && !containsObituary) {
                          return true;
                        }

                        // Disable Sundays
                        if (isSunday && !location.pathname.includes('/obituary/')) {
                          return true;
                        }

                        // Disable Dvobroj
                        if (isDvobroj && !location.pathname.includes('/obituary')) return true;

                        // Disable Holiday
                        if ((isHoliday || isHolidaySecond) && !location.pathname.includes('/obituary')) return true;

                        // Disable Trobroj
                        if (
                          (isTrobrojFirst || isTrobrojSecond || isTrobrojThird) &&
                          !location.pathname.includes('/obituary')
                        )
                          return true;

                        if (
                          currentDate.add(1, 'day').isSame(selectedDate) &&
                          currentTime > '17:00' &&
                          !containsObituary
                        ) {
                          return true;
                        }

                        if (containsObituary && moment().diff(current, 'days') <= 7) {
                          return false;
                        }

                        // currentDay === 6 je subota
                        if (currentDay === 6 && newDate.format('YYYY-MM-DD') === customDate) {
                          return true;
                        }

                        return current && current < moment(customDate, 'YYYY-MM-DD');
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    name="numOfPersons"
                    label={t('article:num of persons')}
                    style={{ marginLeft: '20px', width: '140px', marginBottom: '0px' }}
                    className="numOfPer"
                  >
                    {/* <InputNumber
                      min={1}
                      max={48}
                      defaultValue={1}
                      onChange={onChangePersonNumber}
                      style={{ borderRadius: '5px' }}
                    /> */}

                    <Dropdown overlay={menu} trigger={['click']} className="dd-numOfPersons borderRadius">
                      <Button>
                        <Space>
                          {selectedOption ? selectedOption : 1}
                          <DownOutlined />
                        </Space>
                      </Button>
                    </Dropdown>
                  </Form.Item>
                  {/* {location.pathname.includes('/obituary/') && (
                    <Form.Item
                      name="billId"
                      label={t('article:billId')}
                      style={{ marginLeft: '20px', width: '140px', marginBottom: '0px' }}
                      // rules={[{ required: true, message: 'Molimo unesite broj računa' }]}
                    >
                      <Input></Input>
                    </Form.Item>
                  )} */}
                </div>

                <Form.Item
                  name={'city'}
                  style={{ marginTop: '10px', width: '200px' }}
                  label={'Grad'}
                  className="textType borderRadius"
                  //rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    placeholder={'Odaberite lokaciju'}
                    //value={{ value: null, label: 'Odaberite lokaciju' }}
                    options={Object.values(citiesListNew).map((type: any) => ({
                      label: type,
                      value: type === 'Odaberite lokaciju' ? null : type,
                    }))}
                  />
                </Form.Item>
                <Form.Item
                  label={t('article:personal_message')}
                  name="personal_message"
                  //rules={[{ required: true }]}
                  style={{ marginBottom: '20px' }}
                  className="personalMsg-width "
                >
                  <Input
                    className="borderRadius"
                    spellCheck={false}
                    style={{ width: '100%' }}
                    maxLength={255}
                    showCount={true}
                  />
                </Form.Item>
                <Form.Item
                  label={t('article:intro')}
                  name="intro"
                  rules={[{ required: true }]}
                  style={{ marginBottom: '20px' }}
                  className="personalMsg-width borderRadius"
                >
                  <Input.TextArea
                    className="borderRadius"
                    spellCheck={false}
                    style={{ width: '100%', height: '100px', touchAction: 'manipulation' }}
                    placeholder={t('article:introRecomendation')}
                    onTouchStart={(e) => e.stopPropagation()}
                    onChange={handleInputChange}
                    //style={{ width: '100%' }}
                    //maxLength={255}
                    //showCount={true}
                  />
                </Form.Item>
                {obituaries.map((input, index) => {
                  return (
                    <>
                      {isBreakpoint === false ? (
                        <>
                          <div className="flex nameColumn ">
                            <Form.Item
                              name={'name' + index}
                              rules={[{ required: true, message: 'Molimo unesite Ime' }]}
                              label={t('article:name&surname')}
                            >
                              <Input
                                spellCheck={false}
                                placeholder={t('article:name')}
                                style={{ width: '150px' }}
                                onChange={handleInputChange}
                                className="borderRadius"
                              />
                            </Form.Item>
                            <Form.Item name={'additionalName' + index}>
                              <Input
                                spellCheck={false}
                                placeholder={t('article:additionalName')}
                                style={{ width: '230px', marginTop: '30px', marginLeft: '20px', marginRight: '20px' }}
                                className="borderRadius"
                              />
                            </Form.Item>
                            <Form.Item
                              name={'surname' + index}
                              //rules={[{ required: true, message: 'Molimo unesite Prezime' }]}
                            >
                              <Input
                                spellCheck={false}
                                placeholder={t('article:surname')}
                                style={{ width: '200px', marginTop: '30px' }}
                                className="borderRadius"
                              />
                            </Form.Item>
                          </div>
                          <Form.Item name={'maidenName' + index}>
                            <Input
                              spellCheck={false}
                              placeholder={t('article:maidenName')}
                              style={{ width: '230px', marginRight: '20px' }}
                              className="borderRadius"
                            />
                          </Form.Item>
                        </>
                      ) : (
                        <>
                          <div className="flex nameColumn">
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <Form.Item
                                name={'name' + index}
                                rules={[{ required: true, message: 'Molimo unesite Ime' }]}
                                label={t('article:name&surname')}
                              >
                                <Input
                                  spellCheck={false}
                                  placeholder={t('article:name')}
                                  style={{ width: '150px' }}
                                  className="name-input borderRadius"
                                  onChange={handleInputChange}
                                />
                              </Form.Item>
                              <Form.Item
                                name={'surname' + index}
                                //rules={[{ required: true, message: 'Molimo unesite Prezime' }]}
                                className="style-firstname-lastname "
                              >
                                <Input
                                  spellCheck={false}
                                  placeholder={t('article:surname')}
                                  style={{ width: '200px', marginTop: '30px' }}
                                  className="name-input borderRadius"
                                />
                              </Form.Item>
                            </div>
                            <div style={{ display: 'flex' }}>
                              <Form.Item name={'additionalName' + index}>
                                <Input
                                  spellCheck={false}
                                  placeholder={t('article:additionalName')}
                                  style={{ width: '230px', marginTop: '30px', marginLeft: '20px', marginRight: '20px' }}
                                  className="additionalName-input borderRadius"
                                />
                              </Form.Item>
                              <Form.Item name={'maidenName' + index} className="ml-maidenName">
                                <Input
                                  spellCheck={false}
                                  placeholder={t('article:maidenName')}
                                  style={{ width: '230px', marginRight: '20px' }}
                                  className="additionalName-input borderRadius"
                                />
                              </Form.Item>
                            </div>
                          </div>
                        </>
                      )}

                      <div className="flex">
                        <Form.Item
                          name={'dateOfBirth' + index}
                          //rules={[{ required: true, message: 'Molimo unesite \nDatum rođenja' }]}
                          label={t('article:Date of birth')}
                          className="dateOfBirth"
                        >
                          <DatePicker
                            style={{
                              width: '140px',
                              marginTop: '10px',
                              borderRadius: '5px',
                              borderColor: '#d9d9d9',
                              height: '34px',
                              marginRight: '20px',
                            }}
                            format="DD.MM.YYYY"
                            className="publication"
                            disabledDate={(current) => {
                              let customDate = moment().add(1, 'days').format('YYYY-MM-DD');
                              return current && current > moment(customDate, 'YYYY-MM-DD');
                            }}
                          />
                        </Form.Item>
                        <Form.Item
                          name={'dateOfDeath' + index}
                          //rules={[{ required: true, message: 'Molimo unesite \nDatum smrti' }]}
                          label={t('article:Date of death')}
                          className="dateOfDeath"
                        >
                          <DatePicker
                            style={{
                              width: '140px',
                              marginTop: '10px',
                              borderRadius: '5px',
                              borderColor: '#d9d9d9',
                              height: '34px',
                            }}
                            format="DD.MM.YYYY"
                            className="publication"
                            disabledDate={(current) => {
                              let customDate = moment().add(1, 'days').format('YYYY-MM-DD');
                              return current && current > moment(customDate, 'YYYY-MM-DD');
                            }}
                          />
                        </Form.Item>
                      </div>
                      <div className="flex dateApprox-style" style={{ marginTop: '10px' }}>
                        <Form.Item
                          name={'dateApprox' + index}
                          rules={[
                            {
                              pattern: new RegExp(/^[0-9.]*$/),
                              message: 'Dozvoljeno je koristiti samo brojeve i tačke',
                            },
                          ]}
                          label={t('article:date approx')}
                          style={{ width: '140px' }}
                        >
                          <Input placeholder="npr. 1990" className="borderRadius"></Input>
                        </Form.Item>
                        <Form.Item
                          name={'dateEndApprox' + index}
                          rules={[
                            {
                              pattern: new RegExp(/^[0-9.]*$/),
                              message: 'Dozvoljeno je koristiti samo brojeve i tačke',
                            },
                          ]}
                          label={t('article:date end approx')}
                          style={{ marginLeft: '20px', width: '140px' }}
                        >
                          <Input placeholder="npr. 01.01.1990." className="borderRadius"></Input>
                        </Form.Item>
                      </div>

                      {/*  <Form.Item name={'wantAniversary' + index}>
                          <Checkbox
                            style={{ marginTop: '35px', marginLeft: '20px' }}
                            className="radioStyle"
                            onChange={(e: CheckboxChangeEvent) => {
                              obituaries[index].wantAniversary = String(e.target.checked);
                              if (obituary?.people_id[index]?.wantAniversary !== undefined)
                                obituary.people_id[index].wantAniversary = String(e.target.checked);
                              setObituaryType('1');
                              let str = [
                                'dateOfBirth' + index,
                                'dateOfDeath' + index,
                                'dateApprox' + index,
                                'dateEndApprox' + index,
                              ];
                              form.setFieldsValue({
                                [str[0]]: null,
                                [str[1]]: null,
                                [str[2]]: '',
                                [str[3]]: '',
                              });
                              obituaries[index].birth_date = null;
                              obituaries[index].birth_end = null;
                              obituaries[index].birth_approx = '';
                              obituaries[index].birth_end_approx = '';
                              if (obituary?.people_id[index]) {
                                obituary.people_id[index].birth_date = null;
                                obituary.people_id[index].birth_end = null;
                                obituary.people_id[index].birth_approx = '';
                                obituary.people_id[index].birth_end_approx = '';
                              }
                              setTimeout(() => {
                                setObituaryType('3');
                              }, 10);
                            }}
                            defaultChecked={
                              obituary?.people_id[index]
                                ? obituary?.people_id[index]?.wantAniversary === 'true'
                                : obituaries[index].wantAniversary
                                ? obituaries[index].wantAniversary === 'true'
                                : false
                            }
                          >
                            {t('article:wantAnniversary')}
                          </Checkbox>
                        </Form.Item> */}

                      <Form.Item
                        name={'thumbnailImage' + index}
                        style={{ marginTop: '20px', marginBottom: '20px' }}
                        label={t('article:personPicture') + ' ' + Number(index + 1)}
                      >
                        <ImageUpload
                          setImage={setImage}
                          imageIndex={index}
                          currentImage={
                            obituary?.people_id[index]
                              ? obituary?.people_id[index].filename
                              : obituaries[index].filename
                          }
                        ></ImageUpload>
                      </Form.Item>
                      <Form.Item
                        name={'radioGroupImage' + index}
                        initialValue={
                          obituary?.people_id[index] ? Number(obituary?.people_id[index].imagePreferance) : 2
                        }
                        style={{ marginBottom: '0px' }}
                      >
                        <Radio.Group>
                          <Space direction="vertical">
                            <Radio className="radioStyle" value={1}>
                              Želim objaviti sliku preminulog koju je predala porodica
                            </Radio>
                            <Radio className="radioStyle" value={2}>
                              Želim sliku u boji
                            </Radio>
                            <Radio className="radioStyle" value={3}>
                              Želim objavu bez slike
                            </Radio>
                          </Space>
                        </Radio.Group>
                      </Form.Item>
                    </>
                  );
                })}
                <Form.Item
                  name="mainText"
                  label={t('article:mainText')}
                  style={{ marginTop: '20px', marginBottom: '0px' }}
                  className="mainText-style "
                >
                  <Input.TextArea
                    className="borderRadius"
                    spellCheck={false}
                    style={{ width: '100%', height: '197px' }}
                  />
                </Form.Item>
                <Form.Item
                  name="bereaved"
                  label={t('article:bereaved')}
                  rules={[{ required: true }]}
                  style={{ marginTop: '20px', marginBottom: '0px' }}
                  className="bereaved-style "
                >
                  {!location.pathname.includes('/obituary/') ? (
                    <Input
                      className="borderRadius"
                      spellCheck={false}
                      style={{ width: '100%' }}
                      showCount={true}
                      onChange={handleInputChange}
                    />
                  ) : (
                    <Input.TextArea spellCheck={false} style={{ width: '100%', height: '197px' }} />
                  )}
                </Form.Item>
                {/* <span
                  className="innerElement obituaryBereaved"
                  dangerouslySetInnerHTML={{
                    __html: form.getFieldValue('bereaved')?.replace(new RegExp('\r?\n', 'g'), '<br />') || '',
                  }}
                ></span> */}
                <Form.Item name="note" label={t('article:note')} style={{ marginTop: '20px' }} className="note-style">
                  <Input className="borderRadius" spellCheck={false} style={{ width: '100%' }} />
                </Form.Item>
              </div>

              <div className="styleBtnsPrev">
                <Button
                  className="btnMargin  button-bg btnNextPrevStyle"
                  style={{ marginTop: '30px' }}
                  onClick={() => next(1)}
                >
                  <span className="nextSpan">Sljedeće</span>
                  <div className="nextIcon">
                    <IconArrow></IconArrow>
                  </div>
                </Button>
                <Button
                  className="button-bg btnMargin btnNextPrevStyle"
                  style={{ marginTop: '30px', float: 'left' }}
                  onClick={() => prev()}
                >
                  <div className="prevIcon rotate">
                    <IconArrow></IconArrow>
                  </div>
                  <span className="prevSpan">Prethodno</span>
                </Button>
              </div>
            </div>
          </>
        )}
        {current === 2 && (
          <>
            <div className="main-container">
              <div className="left-container">
                <div className="flex pre">
                  <p className="mta" style={{ paddingRight: '10px' }}>
                    Pregled smrtovnice
                  </p>{' '}
                  <Divider />
                </div>
                <div className="outline">
                  <div className="inner-outline">
                    <span className="innerElement introductory_text_style">
                      {form.getFieldValue('personal_message')}
                    </span>
                    <br></br>
                    <span
                      className="innerElement"
                      dangerouslySetInnerHTML={{
                        __html: form.getFieldValue('intro')?.replace(new RegExp('\r?\n', 'g'), '<br />') || '',
                      }}
                    >
                      {/* {form.getFieldValue('intro')} */}
                    </span>
                    <br></br>
                    {obituaries.length === 1 ? (
                      <div>
                        {obituaries[0].filename && (
                          <span className="innerElement">
                            <img src={obituaries[0].filename} alt="1" style={{ width: '87px', height: '120px' }}></img>
                          </span>
                        )}
                        <br></br>
                        <span
                          className="innerElement fullName"
                          style={{ textTransform: 'uppercase', fontFamily: 'DM Sans', fontSize: '22px' }}
                        >
                          {obituaries[0].firstName}{' '}
                          {obituaries[0].additional_name ? '(' + obituaries[0].additional_name + ')' : ''}{' '}
                          {obituaries[0].lastName}
                          {obituaries[0].maiden_name ? ', ROĐ. ' + obituaries[0].maiden_name : ''}
                        </span>
                        <br></br>
                        <span className="innerElement obituaryDate">
                          {obituaries[0].birth_date
                            ? moment(String(obituaries[0].birth_date)).format('DD.MM.YYYY')
                            : obituaries[0].birth_approx}
                          {((obituaries[0].birth_date && obituaries[0].birth_end) ||
                            (obituaries[0].birth_approx && obituaries[0].birth_end_approx) ||
                            (obituaries[0].birth_date && obituaries[0].birth_end_approx) ||
                            (obituaries[0].birth_approx && obituaries[0].birth_end)) &&
                            ' - '}
                          {obituaries[0].birth_end
                            ? moment(String(obituaries[0].birth_end)).format('DD.MM.YYYY')
                            : obituaries[0].birth_end_approx}
                        </span>
                      </div>
                    ) : obituaries.length > 1 ? (
                      <div className="obituary-wrapper">
                        {obituaries.map((p, i) => {
                          return (
                            <div className="obituary-child">
                              {p.filename && (
                                <span className="innerElement fullName">
                                  <img src={p.filename} alt="1" style={{ width: '87px', height: '120px' }}></img>
                                </span>
                              )}
                              <br></br>
                              <span
                                className="innerElement"
                                style={{ textTransform: 'uppercase', fontFamily: 'DM Sans', fontSize: '22px' }}
                              >
                                {p.firstName} {p.additional_name ? '(' + p.additional_name + ')' : ''} {p.lastName}{' '}
                                {p.maiden_name ? ', ROĐ. ' + p.maiden_name : ''}
                              </span>
                              {p.city && <span className="city">{p.city}</span>}
                              {p.birth_date || p.birth_approx || p.birth_end_approx || p.birth_end ? <br /> : <></>}
                              <span className="innerElement bottom-date obituaryDate">
                                {p.birth_date ? moment(String(p.birth_date)).format('DD.MM.YYYY') : p.birth_approx}
                                {(p.birth_date && p.birth_end) ||
                                (p.birth_approx && p.birth_end_approx) ||
                                (p.birth_date && p.birth_end_approx) ||
                                (p.birth_approx && p.birth_end)
                                  ? ' - '
                                  : ''}
                                {p.birth_end ? moment(String(p.birth_end)).format('DD.MM.YYYY') : p.birth_end_approx}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <></>
                    )}
                    <br></br>
                    <span
                      className="innerElement obituatyMainText"
                      dangerouslySetInnerHTML={{
                        __html: form.getFieldValue('mainText')?.replace(new RegExp('\r?\n', 'g'), '<br />') || '',
                      }}
                    >
                      {/* {form.getFieldValue('mainText')} */}
                    </span>
                    <span style={{ marginTop: '20px' }} className="innerElement obituaryBereaved">
                      {/* {form.getFieldValue('bereaved')} */}
                      <span
                        className="innerElement obituaryBereaved"
                        dangerouslySetInnerHTML={{
                          __html: form.getFieldValue('bereaved')?.replace(new RegExp('\r?\n', 'g'), '<br />') || '',
                        }}
                      ></span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="right-container">
                <div className="flex">
                  <p className="mta" style={{ paddingRight: '10px' }}>
                    Cijena
                  </p>{' '}
                  <Divider />
                </div>
                <div>
                  <div className="">
                    <Form.Item label={t('article:Publication date')} name="dateOfPublish" className="flex f-direction">
                      <span className="fright dateOfPublishStyle">
                        {moment(String(form.getFieldValue('publicationTime'))).format('DD.MM.YYYY')}
                      </span>
                    </Form.Item>

                    <Form.Item label={t('article:formatName')} name="formatName" className="flex f-direction">
                      <div className="fright dateOfPublishStyle">{obituaryFormatName}</div>
                    </Form.Item>

                    <Form.Item label={t('article:totalToPay')} name="totalToPay" className="flex f-direction">
                      <div className="fright pricestyless">{calculatePrice(obituaries.length)} KM</div>
                    </Form.Item>
                    <Divider></Divider>
                    {/* <span>Molimo Vas da ispod ostavite Vaš kontakt broj</span> */}
                    <Form.Item
                      label={'Molimo Vas ostavite Vaš kontakt'}
                      name="leaveNumber"
                      className="flex leaveNumber-style"
                      rules={[
                        {
                          // pattern: new RegExp(/^\+(?:[0-9]●?){6,14}[0-9]$/),
                          pattern: new RegExp(/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/),
                          required: location.pathname.includes('objavi') ? true : false,
                          message: 'Molimo unesite validan kontakt broj',
                        },
                      ]}
                    >
                      <Input placeholder="npr. +387 33 281 356"></Input>
                    </Form.Item>
                    <Form.Item
                      name="nameSurname"
                      className="flex leaveNumber-style"
                      rules={[
                        {
                          // pattern: new RegExp(/^\+(?:[0-9]●?){6,14}[0-9]$/),
                          required: location.pathname.includes('objavi') ? true : false,
                          message: 'Molimo unesite ime i prezime',
                        },
                      ]}
                    >
                      <Input placeholder="Ime i prezime"></Input>
                    </Form.Item>
                    {location.pathname.includes('objavi') && (
                      <>
                        <Form.Item
                          label={'Popunite sljedeća polja ukoliko uplatu vrši pravno lice'}
                          name="companyName"
                          className="flex leaveNumber-style"
                          rules={[
                            {
                              // pattern: new RegExp(/^\+(?:[0-9]●?){6,14}[0-9]$/),
                              // required: location.pathname.includes('objavi') ? true : false,
                              message: 'Molimo unesite naziv firme/pravnog lica',
                            },
                          ]}
                        >
                          <Input placeholder="Naziv firme/pravnog lica"></Input>
                        </Form.Item>
                        <Form.Item
                          name="companyAddress"
                          className="flex leaveNumber-style"
                          rules={[
                            {
                              // pattern: new RegExp(/^\+(?:[0-9]●?){6,14}[0-9]$/),
                              // required: location.pathname.includes('objavi') ? true : false,
                              message: 'Molimo unesite adresu firme',
                            },
                          ]}
                        >
                          <Input placeholder="Adresa firme"></Input>
                        </Form.Item>
                        <Form.Item
                          name="companyPDV"
                          className="flex leaveNumber-style"
                          rules={[
                            {
                              // pattern: new RegExp(/^\+(?:[0-9]●?){6,14}[0-9]$/),
                              // required: location.pathname.includes('objavi') ? true : false,
                              message: 'Molimo unesite ID/PDV broj firme',
                            },
                          ]}
                        >
                          <Input placeholder="ID/PDV broj firme"></Input>
                        </Form.Item>
                      </>
                    )}
                    <span>
                      <b>Napomene:</b> Dnevni avaz vikendom izlazi kao dvobroj.
                      <br />
                      <br /> Molimo Vas da smrtovnice uplatite do 17:00, ukoliko želite da iste budu objavljene sutradan
                      u printanom izdanju.
                      <br />
                      <br /> U cijenu je uključena objava smrtovnice na portalu.
                    </span>
                  </div>

                  <Button
                    className=""
                    onClick={() => prev()}
                    style={{
                      border: '1px #8b8b8b solid',
                      borderRadius: '5px',
                      width: '121px',
                      height: '35px',
                      marginTop: '18px',
                      font: 'DM Sans',
                      fontWeight: 700,
                      fontSize: '14px',
                      fontFamily: 'DM Sans',
                      lineHeight: '18px',
                      letterSpacing: '0em',
                      textAlign: 'center',
                      color: '#8b8b8b',
                    }}
                  >
                    IZMJENI
                  </Button>

                  <input
                    type="submit"
                    form="obituaryForm"
                    className="payment-style"
                    value={!location.pathname.includes('/obituary') ? 'Na plaćanje' : 'Odobri'}
                    style={{
                      height: '35px',
                      width: '159px',
                      background: '#12CE78',
                      font: 'DM Sans',
                      fontWeight: 700,
                      fontSize: '14px',
                      color: '#FFFFFF',
                      textTransform: 'uppercase',
                      borderRadius: '5px',
                      border: 'none',
                      cursor: 'pointer',
                      marginLeft: '20px',
                      marginTop: '18px',
                      fontFamily: 'DM Sans',
                      lineHeight: '18px',
                      letterSpacing: '0em',
                      textAlign: 'center',
                    }}
                    onClick={() => {
                      setObituaryInfo({
                        leaveNumber: form.getFieldValue('leaveNumber'),
                        nameSurname: form.getFieldValue('nameSurname'),
                        companyName: form.getFieldValue('companyName'),
                        companyAddress: form.getFieldValue('companyAddress'),
                        companyPDV: form.getFieldValue('companyPDV'),
                        publishedDate: form.getFieldValue('publicationTime'),
                        personal_message: form.getFieldValue('personal_message'),
                        introductory_text: form.getFieldValue('intro'),
                        main_text: form.getFieldValue('mainText'),
                        bereaved: form.getFieldValue('bereaved'),
                        note: form.getFieldValue('note'),
                        num_of_persons: selectedOption,
                        city: form.getFieldValue('city'),
                        //billId: form.getFieldValue('billId'),
                      });
                      //TODO: provjeriti da li treba async/await ili timeout ukoliko se jedna od formi ne submita kako treba
                    }}
                  />
                </div>
              </div>
            </div>
            <div style={{ borderBottom: '1px solid #E3E3E3' }}></div>
            {!location.pathname.includes('/obituary') && <Payment uuid={uuidState} isCreated={isCreated} fun={fun} />}

            {/* <Button
              type="primary"
              htmlType="submit"
              className="button-bg"
              onClick={() => {
                next(2);
              }}
            >
              <IconArrow></IconArrow>
            </Button> */}
          </>
        )}
        {/* <Steps current={current} style={{ marginBottom: '10px' }}>
        {steps.map((item) => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps> */}
      </Form>
    </>
  );
};
